import { render, staticRenderFns } from "./CreateCutting.vue?vue&type=template&id=208bcc05"
import script from "./CreateCutting.vue?vue&type=script&lang=js"
export * from "./CreateCutting.vue?vue&type=script&lang=js"
import style0 from "./CreateCutting.vue?vue&type=style&index=0&id=208bcc05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports